import React from "react";
import { useOutlet } from "react-router";
import styled from "styled-components";

import { Fonts } from "assets/fonts";
import { SidePanelPortal } from "ui/components/_templates/sidePanel/SidePanelPortal";
import { palette } from "ui/styles/palette";
import { viewPortBreakpoints } from "ui/styles/viewport";

const MainContent = styled.main`
  display: flex;
  flex-direction: column;
  gap: 8px;
  height: 100%;
  width: 100%;
  overflow: auto;
  background: ${palette.backgroundSecondary};
  padding: 16px 16px 32px;

  @media (min-width: ${viewPortBreakpoints.lg}) {
    padding: 24px 24px 32px;
    gap: 16px;
  }
  @media (min-width: ${viewPortBreakpoints.xl}) {
    padding: 32px;
    gap: 24px;
  }
`;

interface MainViewTemplateProps {
  children?: React.ReactNode;
  panelContext?: unknown;
}
export const MainViewTemplate = (props: MainViewTemplateProps) => {
  const { children, panelContext } = props;
  const outlet = useOutlet(panelContext);

  return (
    <>
      <MainContent>{children}</MainContent>
      <SidePanelPortal isOpen={!!outlet}>{outlet}</SidePanelPortal>
    </>
  );
};

// --- Sub-components ---
MainViewTemplate.Header = styled.header`
  display: flex;
  justify-content: space-between;
`;

MainViewTemplate.ViewTitle = styled.h1`
  margin: 0;
  ${Fonts.semiBold_24}
  color: ${(p) => p.theme.textHighestContrast};
`;
